export default __webpack_public_path__ + "static/media/Japan_Particle_0007_Tenko_Blast1.dac7a766.png";